import styled from 'styled-components';
export const BackdropWrapper = styled.div`
  ${props => props.open ? 'opacity:1; transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;' : 'opacity:0; transition: opacity 195ms cubic-bezier(0.4, 0, 0.2, 1) 0ms; '}
  top:0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  position: fixed;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-tap-highlight-color: transparent;
`;